module.exports = __webpack_public_path__ + "img/review.babc1171.png";